module.exports = __webpack_public_path__ + "img/Research_Armadillo.e73bff40.svg";